export function saveTeamData(data) {
  return { type: "TEAM_LIST", data: data };
}
